/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DestinationFromJSON, DestinationToJSON, } from './';
export function DestinationTutorialExitsEntryFromJSON(json) {
    return DestinationTutorialExitsEntryFromJSONTyped(json, false);
}
export function DestinationTutorialExitsEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'key': !exists(json, 'key') ? undefined : json['key'],
        'value': !exists(json, 'value') ? undefined : DestinationFromJSON(json['value']),
    };
}
export function DestinationTutorialExitsEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'key': value.key,
        'value': DestinationToJSON(value.value),
    };
}
//# sourceMappingURL=DestinationTutorialExitsEntry.js.map